import { render, staticRenderFns } from "./projectWatchlist.vue?vue&type=template&id=5c88385e&"
import script from "./projectWatchlist.vue?vue&type=script&lang=js&"
export * from "./projectWatchlist.vue?vue&type=script&lang=js&"
import style0 from "./projectWatchlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports